
export default "/assets/plausible.8d4f0ea2.svg"